import { getLogger } from '@jitsi/logger';
import { hideDialog, openDialog } from '../../../react/features/base/dialog/actions';
import { translateToHTML } from '../../../react/features/base/i18n/functions';
import { browser } from '../../../react/features/base/lib-jitsi-meet';
import {
    getLocalParticipant,
    getParticipantDisplayName,
    getVirtualScreenshareParticipantByOwnerId
} from '../../../react/features/base/participants/functions';
import { toggleScreensharing } from '../../../react/features/base/tracks/actions';
import { getLocalJitsiDesktopTrack } from '../../../react/features/base/tracks/functions';
import {
    disableKeyboardShortcuts,
    enableKeyboardShortcuts
} from '../../../react/features/keyboard-shortcuts/actions';
import { showNotification, showWarningNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../react/features/notifications/constants';
import {
    getKey,
    getModifiers,
    getRemoteConrolEventCaptureArea
} from '../../../react/features/remote-control/functions';
const logger = getLogger(__filename);

import _debounce from 'lodash/debounce';
import { RequestControlDialog } from '../../components/wildix-remote-control';
import WildixXMPPEvents from '../../service/xmpp/WildixXMPPEvents';

import { sendKinesisEvent } from '../analytics/kinesis/actions';

import {
    ADD_WAITING_QUEUE,
    ALLOWED_USER_ID,
    CONTROL_SHARING_TOGGLE,
    EVENT_DATA_SERVICE,
    REMOVE_WAITING_QUEUE,
    SET_ADMIN_STATE_CONTROL,
    SET_AUTOSTART_SHARING,
    SET_CONTROLLER_ID,
    SET_SELF_CONTROL,
    SET_STATUS_CONTROL,
    SET_VIRTUAL_SCREEN_ID
} from './actionTypes';
import {
    CONTROL_TIMEOUTS,
    EVENTS,
    FIREHOSE_EVENTS, NOTIFICATION_FROM_USER_BY_KEY,
    REQUEST_TYPES,
    STATUSES,
    WEBRTC_TYPES,
    WISERVICE_TYPES
} from './constants';
import {
    changeHeightSharingForLaunchingUser,
    checkChatInFocus,
    getLinkForDownloadService,
    isVersionSupportControl,
    prepareDataToSend,
    sendDataToWIService,
    toggleVisibilityHeaderContainer
} from './functions';


export function eventScreenControlFromService(message = {}) {
    return {
        type: EVENT_DATA_SERVICE,
        serviceResponse: message.msgdata
    };
}
export function toggleControlSharing(keyValue) {
    return {
        type: CONTROL_SHARING_TOGGLE,
        controlState: keyValue
    };
}

export function setControlledUserID(ID) {
    return {
        type: ALLOWED_USER_ID,
        participantID: ID
    };
}
export function setVirtualScreenSharingID(ID) {
    return {
        type: SET_VIRTUAL_SCREEN_ID,
        virtualScreenID: ID
    };
}

export function setSelfControl(stateValue) {
    return {
        type: SET_SELF_CONTROL,
        isUserGivesSelfControl: stateValue
    };
}
export function setStatusControl(status) {
    return {
        type: SET_STATUS_CONTROL,
        statusControl: status
    };
}
export function setLaunchedUserID(ID) {
    return {
        type: SET_CONTROLLER_ID,
        participantID: ID
    };
}
export function toggleAutoStartSharing(stateValue) {
    return {
        type: SET_AUTOSTART_SHARING,
        isAutoStart: stateValue
    };
}

export function addWaitingQueue(objectQueue, userID) {
    return {
        type: ADD_WAITING_QUEUE,
        objectQueue,
        userID
    };
}
export function removeWaitingQueue(deleteID) {
    return {
        type: REMOVE_WAITING_QUEUE,
        deleteID
    };
}
export function toggleAdminState(userState) {
    return {
        type: SET_ADMIN_STATE_CONTROL,
        isUserAdmin: userState
    };
}
export function setDefaultStoreControlSharing() {
    return (dispatch: Function, getState: Function) => {
        dispatch(setStatusControl(STATUSES.CLOSED));
        dispatch(setLaunchedUserID(null));
        dispatch(setControlledUserID(null));
        dispatch(setVirtualScreenSharingID(null));
        dispatch(toggleAdminState(null));
        dispatch(toggleAutoStartSharing(false));
    };
}
export function togglePauseResumeControl(pauseState) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { statusControl } = state['wildix/features/control-sharing'];

        if (pauseState && statusControl !== STATUSES.PAUSED) {
            dispatch(setStatusControl(STATUSES.PAUSED));
            dispatch(pauseMouseEvents());
            dispatch(showNotification({
                descriptionKey: 'controlSharing.onMainScreenNotUser',
                titleKey: 'controlSharing.titleDialogControl'
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        } else if (!pauseState && statusControl !== STATUSES.OPENED) {
            dispatch(setStatusControl(STATUSES.OPENED));
            dispatch(resumeMouseEvents());
            dispatch(showNotification({
                descriptionKey: 'controlSharing.onMainScreenUser',
                titleKey: 'controlSharing.titleDialogControl'
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        }

        dispatch(toggleSelectorControlSharing());
    };
}
export function toggleSelectorControlSharing() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const localParticipantId = getLocalParticipant(state)?.id;
        const { active, isUserAdmin } = state['wildix/features/control-sharing'];
        const { controlledUserId, launchedControlID, virtualScreenID } = state['wildix/features/control-sharing'];

        if (!controlledUserId || active === null) {
            return;
        }

        setTimeout(() => {
            const documentBody = document.body;
            const participantSelector = document.getElementById(localParticipantId === controlledUserId
                ? 'localVideoContainer' : `participant_${controlledUserId}`);
            const participantSelectorVirtual = document.getElementById(`participant_${virtualScreenID}`);
            const participantLaunchedSelector = document.getElementById(localParticipantId === launchedControlID
                ? 'localVideoContainer' : `participant_${launchedControlID}`);

            if (active) {
                if (!isUserAdmin) {
                    documentBody.classList.add('controlled');
                }

                participantSelector?.setAttribute('controlled-user', '');
                participantSelectorVirtual?.setAttribute('controlled-user', '');
                participantLaunchedSelector?.setAttribute('launched-control-user', '');
            } else {
                documentBody.classList.remove('controlled');
                participantSelector?.removeAttribute('controlled-user');
                participantSelectorVirtual?.removeAttribute('controlled-user');
                participantLaunchedSelector?.removeAttribute('launched-control-user');
            }
        }, 50);
    };
}
export function addQueryDialog(objectQueue, userID) {
    return (dispatch: Function, getState: Function) => {
        dispatch(addWaitingQueue(objectQueue, userID));
    };
}
export function callQueryDialogByStep() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { arrayQueue } = state['wildix/features/control-sharing'];

        if (arrayQueue.size === 0) {
            return;
        }

        const [ firstKey ] = arrayQueue.keys();
        const [ firstValue ] = arrayQueue.values();

        // Wait until the previous dialog closes with animation
        setTimeout(() => {
            dispatch(setStatusControl(STATUSES.REQUESTING));
            dispatch(openDialog(RequestControlDialog, firstValue));
            dispatch(removeWaitingQueue(firstKey));
        }, CONTROL_TIMEOUTS.queueDialogDelay);
    };
}

export function hideRequestControlDialog() {
    return (dispatch: Function, getState: Function) => {
        const { componentProps = {} } = getState()['features/base/dialog'];
        const {
            CONTROL_DIALOG_REQUEST,
            launchedName
        } = componentProps;

        if (CONTROL_DIALOG_REQUEST === REQUEST_TYPES.CONTROL_DIALOG_REQUEST) {
            dispatch(hideDialog(RequestControlDialog));
            dispatch(showWarningNotification({
                titleKey: 'controlSharing.titleDialogControl',
                descriptionKey: 'controlSharing.userLeftRoomOrSharing',
                descriptionArguments: { name: launchedName }
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            dispatch(setStatusControl(null));
        }
    };
}

export function stopController() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];

        dispatch(pauseMouseEvents());
        dispatch(toggleControlSharing(false));
        logger.warn('stopController');
        dispatch(setStatusControl(STATUSES.CLOSED));

        APP.wildix.controlSharing.disconnectAndSendEvent();
        changeHeightSharingForLaunchingUser(false, { state,
            dispatch });
        toggleVisibilityHeaderContainer(false);
        conference.removeLocalParticipantProperty(WildixXMPPEvents.CONTROL_SHARING_DATA);
    };
}
export function sendEventToCloseConnection() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();

        const { launchedControlID, controlledUserId } = state['wildix/features/control-sharing'];

        logger.warn('sendEventToCloseConnection');
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_CLOSE,
            controlledUserId,
            launchedControlID
        });

        dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));
    };
}

export function createRequest(participantID, isUserGivesSelfControl) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const userID = conference.myUserId();

        logger.warn(isUserGivesSelfControl, 'createRequest');

        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL,
            isUserGivesSelfControl,
            launchedControlID: userID,
            controlledUserId: participantID
        });

        dispatch(setSelfControl(isUserGivesSelfControl));
        dispatch(setStatusControl(STATUSES.REQUESTING));

        if (isUserGivesSelfControl) {
            dispatch(setLaunchedUserID(participantID));
            dispatch(setControlledUserID(userID));
        } else {
            dispatch(setLaunchedUserID(userID));
            dispatch(setControlledUserID(participantID));
        }
        dispatch(sendMessageToCurrentUser(participantID, preparedData));
    };
}
export function controlSharingIsBusy(participantID, controlledUserId) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];


        logger.warn('controlSharingIsBusy');

        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_BUSY,
            launchedControlID: participantID,
            controlledUserId
        });

        dispatch(sendMessageToCurrentUser(participantID, preparedData));
    };
}

export function showNotificationFromRemoteUser(type, remoteUserID) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();

        logger.warn(type, remoteUserID, 'showNotificationFromRemoteUser');

        dispatch(showNotification({
            descriptionArguments: { name: getParticipantDisplayName(state, remoteUserID) },
            descriptionKey: NOTIFICATION_FROM_USER_BY_KEY[type] ?? '',
            titleKey: 'controlSharing.titleDialogControl'
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
    };
}

export function sendEventServiceNotInstalled(participantID, isSelfControl) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const userID = conference.myUserId();

        logger.warn('sendEventToCloseConnection');
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_NOT_INSTALLED,
            isUserGivesSelfControl: isSelfControl,
            launchedControlID: participantID,
            controlledUserId: userID
        });

        if (isSelfControl) {
            dispatch(showNotificationIfNoWiService(REQUEST_TYPES.CONTROL_NOT_INSTALLED, userID, isSelfControl));
        } else {
            dispatch(showNotificationIfNoWiService('', participantID, !isSelfControl));
            dispatch(sendMessageToCurrentUser(participantID, preparedData));
        }
    };
}

export function wildixServiceDisconnected() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { launchedControlID } = state['wildix/features/control-sharing'];

        logger.warn('wildixServiceDisconnected');
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: WISERVICE_TYPES.serviceStopped
        });

        dispatch(showWarningNotification({
            descriptionKey: 'controlSharing.wildixServiceDisconnected',
            titleKey: 'controlSharing.titleDialogControl'
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));

        dispatch(setStatusControl(STATUSES.STOPPED));

        dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));
    };
}
export function wildixServiceRestored() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { isUserGivesSelfControl, launchedControlID } = state['wildix/features/control-sharing'];


        if (!isVersionSupportControl(state)) {
            logger.warn('wildixServiceRestored wrong version');
            dispatch(sendEventServiceNotInstalled(launchedControlID, isUserGivesSelfControl));

            return;
        }

        logger.warn('wildixServiceRestored');
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: WISERVICE_TYPES.serviceConnected
        });

        dispatch(showNotification({
            descriptionKey: 'controlSharing.wildixServiceRestored',
            titleKey: 'controlSharing.titleDialogControl'
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));

        dispatch(setStatusControl(STATUSES.OPENED));

        dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));

        dispatch(sendDataSharingToWiService());
    };
}
export function notificationStatusService(connectionStatus) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { controlledUserId } = state['wildix/features/control-sharing'];
        let descriptionKey = '';

        if (connectionStatus === WISERVICE_TYPES.serviceStopped) {
            descriptionKey = 'controlSharing.wildixServiceDisconnectedRemoteUser';
        } else if (connectionStatus === WISERVICE_TYPES.serviceConnected) {
            descriptionKey = 'controlSharing.wildixServiceRestoredRemoteUser';
        }
        dispatch(showNotification({
            titleKey: 'controlSharing.titleDialogControl',
            descriptionKey,
            descriptionArguments: { name: getParticipantDisplayName(state, controlledUserId) }
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    };
}

export function showNotificationIfNoWiService(type, remoteUserID, isUserGivesSelfControl) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();

        let descriptionKey = '';
        let descriptionValue = '';
        let descriptionHTML = '';
        let descriptionArguments = {};

        if (type === REQUEST_TYPES.CONTROL_NOT_INSTALLED && !isUserGivesSelfControl) {
            descriptionKey = 'controlSharing.remoteUserNotHasService';
            descriptionArguments = { name: getParticipantDisplayName(state, remoteUserID) };
        } else {
            descriptionValue = 'controlSharing.localUserNotHaveService';
            descriptionHTML = translateToHTML(APP.wildix.methods.translate, descriptionValue, {
                pageUrl: getLinkForDownloadService()
            });
        }
        dispatch(showWarningNotification({
            titleKey: 'controlSharing.titleDialogControl',
            descriptionArguments,
            descriptionKey,
            description: descriptionHTML
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    };
}

export function userApproved(launchedControlID, controlledUserId) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const userID = conference.myUserId();
        const { isUserGivesSelfControl } = state['wildix/features/control-sharing'];
        const { localScreenShare } = state['features/base/participants'];
        const virtualScreenID = isUserGivesSelfControl
            ? getVirtualScreenshareParticipantByOwnerId(state, controlledUserId)?.id
            : localScreenShare?.id;

        logger.warn(launchedControlID, controlledUserId, isUserGivesSelfControl, 'userApproved');
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_APPROVED,
            launchedControlID,
            virtualScreenID,
            isUserGivesSelfControl,
            controlledUserId
        });

        dispatch(setStatusControl(STATUSES.PENDING));
        dispatch(setLaunchedUserID(launchedControlID));
        dispatch(setControlledUserID(controlledUserId));
        dispatch(setVirtualScreenSharingID(virtualScreenID));
        dispatch(toggleAdminState(launchedControlID === userID));

        if (isUserGivesSelfControl) {
            dispatch(createDataChanel());
            dispatch(sendMessageToCurrentUser(controlledUserId, preparedData));
        } else {
            dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));
        }
        dispatch(sendEventToFirehose(FIREHOSE_EVENTS.requestApproved));

        dispatch(sendRejectToUsersInQueue());
    };
}

export function openDialogWithSharing(launchedControlID, controlledUserId) {
    return (dispatch: Function, getState: Function) => {
        dispatch(setControlledUserID(controlledUserId));
        dispatch(setLaunchedUserID(launchedControlID));
        dispatch(toggleAutoStartSharing(true));
        dispatch(toggleScreensharing(true));
    };
}

export function sendRejectToUsersInQueue() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { arrayQueue } = state['wildix/features/control-sharing'];

        if (arrayQueue.size === 0) {
            return;
        }

        for (const userId of arrayQueue.keys()) {
            dispatch(userRejected(userId));
        }
        dispatch(removeWaitingQueue());
    };
}

export function sendDataSharingToWiService() {
    return (dispatch: Function, getState: Function) => {
        let videoTrackOptions = {};

        const { track } = getLocalJitsiDesktopTrack(getState()) || {};

        if (track) {
            const getTrackSettings = track.getSettings();

            if (browser.isFirefox()) {
                videoTrackOptions.label = track?.label;
            }

            videoTrackOptions = {
                ...videoTrackOptions,
                ...getTrackSettings
            };
            logger.warn(videoTrackOptions, track, 'videoTrackOptions');
        }


        sendDataToWIService(WISERVICE_TYPES.messageType, {
            msgdata: {
                command: WISERVICE_TYPES.commandStart,
                displayParams: videoTrackOptions
            }
        });
    };
}

export function userRejected(launchedControlID) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];
        const { launchedControlID: launchedControlIDStore } = state['wildix/features/control-sharing'];

        const userID = conference.myUserId();

        logger.warn('userRejected');
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_REJECTED,
            launchedControlID,
            controlledUserId: userID
        });

        if (launchedControlID === launchedControlIDStore || !launchedControlIDStore) {
            dispatch(setDefaultStoreControlSharing());
        }
        dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));
    };
}

export function sendMessageToCurrentUser(toUserID, preparedData) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { conference } = state['features/base/conference'];

        logger.warn(toUserID, 'toUserID');
        if (!conference) {
            return;
        }

        conference.sendPrivateTextMessage(toUserID, preparedData, WEBRTC_TYPES.TYPE_MESSAGE);
    };
}

// TODO: Remove after Wi Service add support and web part
export function showNotificationSharingTab(controlledUserId, launchedControlID) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();

        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_REJECTED_TAB,
            launchedControlID,
            controlledUserId
        });

        dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));
    };
}

// TODO: Remove after Wi Service add support and web part
export function showNotificationSharingFirefox(controlledUserId, launchedControlID) {
    return (dispatch: Function, getState: Function) => {
        const preparedData = prepareDataToSend({
            isRequestControl: true,
            type: REQUEST_TYPES.CONTROL_REJECTED_FIREFOX,
            launchedControlID,
            controlledUserId
        });

        dispatch(sendMessageToCurrentUser(launchedControlID, preparedData));
    };
}

/**
 * Pauses the collecting of events and enables the keyboard shortcus. But
 * it doesn't removes any other listeners. Basically the remote control
 * session will be still active after the pause action, but no events from the
 * controller side will be captured and sent. You can resume the collecting
 * of the events with the resume action.
 *
 * @returns {Function}
 */
export function pauseMouseEvents() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();

        logger.log('Pausing remote control controller.');

        dispatch(enableKeyboardShortcuts());

        const area = getRemoteConrolEventCaptureArea();

        if (area) {
            area.off('contextmenu');
            area.off('dblclick');

            area.off('mousedown');
            area.off('mousemove');
            area.off('mouseenter');
            area.off('mouseleave');
            area.off('mouseup');
            area[0].onwheel = undefined;
        }

        $(window).off('keydown');
        $(window).off('keyup');
    };
}

export function dataChanelOpened() {
    return (dispatch: Function, getState: Function) => {
        logger.warn('dataChanelOpened');
        const state = getState();
        const { conference } = state['features/base/conference'];
        const { isUserAdmin } = state['wildix/features/control-sharing'];

        dispatch(toggleControlSharing(true));

        if (isUserAdmin) {
            dispatch(resumeMouseEvents());
        } else {
            dispatch(sendDataSharingToWiService());
        }
        dispatch(sendToAllUserStatusSharing(STATUSES.OPENED));
    };
}

export function sendToAllUserStatusSharing(status) {
    return (dispatch: Function, getState: Function) => {
        logger.warn(status, 'sendToAllUserStatusSharing status');
        const state = getState();
        const { conference } = state['features/base/conference'];
        const { launchedControlID, controlledUserId } = state['wildix/features/control-sharing'];

        const preparedData = prepareDataToSend({
            status,
            launchedControlID,
            controlledUserId
        });

        conference?.setLocalParticipantProperty(WildixXMPPEvents.CONTROL_SHARING_DATA, preparedData);
        if (status === STATUSES.CLOSED) {
            conference.removeLocalParticipantProperty(WildixXMPPEvents.CONTROL_SHARING_DATA);
        }
    };
}
export function dataChanelClosed(typeMessage = REQUEST_TYPES.CONTROL_WAS_STOPPED, failed = false) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();
        const { active, isUserAdmin } = state['wildix/features/control-sharing'];

        logger.warn(active, 'dataChanelClosed active');
        if (!active && !failed) {
            return;
        }

        if (isUserAdmin) {
            changeHeightSharingForLaunchingUser(false,
                {
                    state,
                    dispatch
                });
            toggleVisibilityHeaderContainer(false);
        }

        dispatch(pauseMouseEvents());
        dispatch(toggleControlSharing(false));
        dispatch(showNotificationFromRemoteUser(typeMessage));

        sendDataToWIService(WISERVICE_TYPES.messageType, {
            msgdata: {
                command: WISERVICE_TYPES.commandStop
            }
        });
        dispatch(sendToAllUserStatusSharing(STATUSES.CLOSED));
    };
}

export function sendEventToFirehose(message) {
    return (dispatch: Function, getState: Function) => {
        dispatch(sendKinesisEvent({
            message
        }));
    };
}

export function createDataChanel() {
    return (dispatch: Function, getState: Function) => {
        const state = getState();


        // const { conference } = state['features/base/conference'];
        // const userID = conference.myUserId();
        logger.warn('createDataChanel');

        changeHeightSharingForLaunchingUser(true, { state,
            dispatch });
        toggleVisibilityHeaderContainer(true);
        APP.wildix.controlSharing.initDataChanel();
    };
}
export function resumeMouseEvents() {
    return (dispatch: Function, getState: Function) => {
        const area = getRemoteConrolEventCaptureArea();
        const state = getState();
        const { active } = state['wildix/features/control-sharing'];

        logger.warn(active, 'active Resuming remote control controller.');

        dispatch(disableKeyboardShortcuts());

        area.mousemove(event => {
            dispatch(mouseMoved(event));
        });
        area.mouseenter(() => {
            dispatch(sendEventIfClickedAndLeave(EVENTS.mouseenter));
        });
        area.mouseleave(_debounce(() => {
            dispatch(sendEventIfClickedAndLeave(EVENTS.mouseleave));
        }, CONTROL_TIMEOUTS.mouseLeaveDelay));

        area.mousedown(event => dispatch(mouseClicked(EVENTS.mousedown, event)));
        area.mouseup(event => dispatch(mouseClicked(EVENTS.mouseup, event)));
        area.dblclick(event => dispatch(mouseClicked(EVENTS.mousedblclick, event)));
        area.contextmenu(() => false);
        area[0].onwheel = event => {
            event.preventDefault();
            event.stopPropagation();
            dispatch(mouseScrolled(event));

            return false;
        };

        $(window).keydown(event => dispatch(keyPressed(EVENTS.keydown, event)));
        $(window).keyup(event => dispatch(keyPressed(EVENTS.keyup, event)));
    };
}

/**
 * Handles key press events on the controller side..
 *
 * @param {string} type - The type of event ("keydown"/"keyup").
 * @param {Event} event - The key event.
 * @returns {Function}
 */
export function keyPressed(type: string, event: Object) {
    return (dispatch: Function, getState: Function) => {
        if (checkChatInFocus(getState())) {
            logger.warn('blocked from chat');

            return;
        }
        event.preventDefault();
        event.stopPropagation();
        logger.warn('keyPressed');
        APP.wildix.controlSharing.sendMessageThroughDataChannel({
            code: event.code,
            keyEvent: event.key,
            type,
            key: getKey(event),
            modifiers: getModifiers(event)
        });
    };
}

let eventObjectClicked = {};

export function mouseClicked(type: string, event: Object) {
    return (dispatch: Function, getState: Function) => {
        eventObjectClicked = {
            type,
            button: event.which
        };
        APP.wildix.controlSharing.sendMessageThroughDataChannel(eventObjectClicked);
    };
}


export function sendEventIfClickedAndLeave(typeEvent) {
    return () => {
        const { type, button } = eventObjectClicked;

        if (typeEvent === EVENTS.mouseenter && type === EVENTS.mousedown) {
            logger.warn('mouseenter if');
            eventObjectClicked = {};

            return;
        }

        if (typeEvent === EVENTS.mouseleave && type === EVENTS.mousedown) {
            logger.warn('sendEventIfClickedAndLeave');
            APP.wildix.controlSharing.sendMessageThroughDataChannel({
                type: EVENTS.mouseup,
                button
            });
            eventObjectClicked = {};
        }
    };
}

export function mouseScrolled(event: Object) {
    return (dispatch: Function, getState: Function) => {
        APP.wildix.controlSharing.sendMessageThroughDataChannel({
            type: EVENTS.mousescroll,
            x: event.deltaX,
            y: event.deltaY
        });
    };
}

/**
 * Handles mouse moved events on the controller side.
 *
 * @param {Event} event - The mouse event.
 * @returns {Function}
 */
export function mouseMoved(event: Object) {
    return (dispatch: Function, getState: Function) => {
        const area = getRemoteConrolEventCaptureArea();

        if (!area) {
            return;
        }

        const position = area.position();

        const objectToSend = {
            message: WISERVICE_TYPES.messageMouseMove,
            movePosition: {
                x: (event.pageX - position.left) / area.width(),
                y: (event.pageY - position.top) / area.height()
            }
        };

        APP.wildix.controlSharing.sendMessageThroughDataChannel(objectToSend);
    };
}
